// src/config.js
const config = {
    API_BASE_URL: "https://real-estate-analyzer.onrender.com",
};

export default config;
